/* Confetti-burst in merk-kleuren wanneer een deal naar WON gaat 🎉
 * Gebruikt door Pipeline.jsx (drag & drop) en LeadDetailDrawer.jsx (stage-knop).
 * Twee zijkanonnen + centrale burst — kort en feestelijk (~1s). */
import confetti from "canvas-confetti";

export function fireWonConfetti() {
    const colors = ["#FF5A00", "#FF7B33", "#10B981", "#F59E0B", "#60A5FA", "#ffffff"];
    confetti({ particleCount: 120, spread: 75, origin: { x: 0.5, y: 0.55 }, colors, scalar: 1.05 });
    setTimeout(() => confetti({ particleCount: 60, angle: 60, spread: 55, origin: { x: 0, y: 0.7 }, colors }), 150);
    setTimeout(() => confetti({ particleCount: 60, angle: 120, spread: 55, origin: { x: 1, y: 0.7 }, colors }), 150);
}
